import axios from "axios";

export const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Auto-refresh access token once on 401, then retry the original request
let refreshPromise = null;
adminApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    const isAuthCall = ["/auth/login", "/auth/refresh", "/auth/logout"].some((p) => url.includes(p));
    if (status === 401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || adminApi.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return adminApi(original);
      } catch (e) {
        refreshPromise = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const apiError = (e) =>
  formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Erreur inconnue";
